import _ from 'lodash';
import React, { Component } from 'react';
import { Table, Button, Popup, Dropdown, Dimmer, Loader, Input, Pagination, List } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import ApplicationReview from './ApplicationReview';
import { get, del, post, put } from '../services/RestUtilities';
import ToastUtilities from './ToastUtilities';

const statusOptions = [
    { key: 'REVIEW', text: 'DCO Review', value: 'REVIEW' },
    { key: 'SUBMITTED', text: 'Submitted', value: 'SUBMITTED' },
    { key: 'EDIT', text: 'In Progress', value: 'EDIT' },
    { key: 'REJECTED', text: 'Review Rejected', value: 'REJECTED' }
];

const pageSizeOptions = [
    { key: 5, text: '5', value: 5 },
    { key: 10, text: '10', value: 10 },
    { key: 20, text: '20', value: 20 },
    { key: 50, text: '50', value: 50 },
    { key: 100, text: '100', value: 100 },
    { key: -1, text: 'All', value: -1 }
];

class ApplicationTable extends Component {

    constructor(props) {
        super(props);

        this.state = {
            applications: [],
            column: null,
            direction: null,
            statusFilter: '',
            idFilter: '',
            coverageFilter: '',
            activePage: 1,
            pageSize: 10,
            resubmitAppEmailLoading: false,
            resubmitAppImagingLoading: false,
        }
    }

    // Update the state
    componentDidUpdate(prevProps) {
        var tmpApps = this.props.applications;
        if (this.props.applications !== prevProps.applications) {
            this.setState({ applications: tmpApps });
        }
    }

    // Other Handlers
    handleDelete = (id) => {
        del(`api/Application/Delete/${id}`)
            .then((response) => {
                if (!response.isError) {
                    var filteredApps = this.state.applications.filter((v, i, a) => {
                        return v.id != id;
                    });
                    this.setState({ applications: filteredApps });
                } else {
                    ToastUtilities.error(response.errorContent.errorMessage);
                }
            });
    }

    handleResubmitEmail = (id) => {
        this.setState({ resubmitAppEmailLoading: true });
        get(`api/Application/ResendCPAPValidationEmail?id=${id}`)
            .then((response) => {
                if (response.isError) {
                    ToastUtilities.error(response.errorContent.errorMessage);
                }
                else {
                    this.setState({ resubmitAppEmailLoading: false });
                    ToastUtilities.success('Email Sent!');
                }
            });
    }

    handleImageApplication = async (id, coverageId) => {
        this.setState({ resubmitAppImagingLoading: true });
        await put(`api/Admin/SendApplicationToImaging?id=${id}&coverageId=${coverageId}`)
            .then((response) => {
                if (response.isError) {
                    ToastUtilities.error(response.errorContent.errorMessage);
                }
                else {
                    this.setState({ resubmitAppImagingLoading: false });
                    ToastUtilities.success('Application Queued for Imaging!');
                }
            });
    }

    handleSort = clickedColumn => () => {
        const { applications, column, direction } = this.state;

        if (column !== clickedColumn) {
            this.setState({
                column: clickedColumn,
                applications: _.sortBy(applications, [clickedColumn]),
                direction: 'ascending',
            });
            return;
        }

        this.setState({
            applictions: applications.reverse(),
            direction: direction === 'ascending' ? 'descending' : 'ascending',
        });
    }

    handleChildSort = (e) => {
        e.stopPropagation();
    }

    handleStatusChange = (e, {value}) => {
        this.setState({ statusFilter: value });
    }

    handleIdChange = (e) => {
        this.setState({ idFilter: e.target.value });
    }

    handleCoverageIdChange = (e) => {
        this.setState({ coverageFilter: e.target.value });
    }

    downloadCPAPPDF = (id) => {
        let anchor = document.createElement("a");
        anchor.setAttribute('id', 'cpapApplicationPDF');
        document.body.appendChild(anchor);
        let headers = new Headers();
        headers.set('Authorization', `Bearer ${this.props.authUser.token}`);
        fetch(`api/Application/DownloadCCPAPReport?id=${id}`, { headers })
            .then((response) => response.blob())
            .then(blob => {
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, 'CCPAP_Application.pdf');
                } else {
                    let objectUrl = window.URL.createObjectURL(blob);
                    anchor.href = objectUrl;
                    anchor.download = 'CCPAP_Application.pdf';
                    anchor.click();
                    window.URL.revokeObjectURL(objectUrl);
                }
                let element = document.getElementById('cpapApplicationPDF');
                document.body.removeChild(element);
            });
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage });

    handlePageSizeChange = (e, { value }) => this.setState({ pageSize: value });

    render() {
        const { column, direction, statusFilter, idFilter, coverageFilter, activePage, pageSize, resubmitAppEmailLoading, resubmitAppImagingLoading } = this.state;
        let applications = this.state.applications;

        if (statusFilter) {
            applications = applications.filter((app) => app.status === statusFilter);
        }

        if (idFilter) {
            applications = applications.filter((app) => app.id.toString().includes(idFilter));
        }

        if (coverageFilter) {
            applications = applications.filter((app) => app.coverageId.indexOf(coverageFilter) > -1);
        }

        let numberOfPages;
        if (pageSize !== -1) {
            numberOfPages = Math.ceil(applications.length / pageSize);
            const pageNumber = activePage - 1;
            applications = applications.slice(pageNumber * pageSize, (pageNumber + 1) * pageSize);
        }

        return (
            <div>
                <Dimmer active={this.props.loading} inverted>
                    <Loader size='large'>Loading</Loader>
                </Dimmer>
                <Table color='green' sortable>
                    <Table.Header>
                        <Table.Row>
                            {(this.props.authUser.role === 'dco' || this.props.authUser.role === 'administrator') && (
                                <Table.HeaderCell
                                    sorted={column === 'id' ? direction : null}
                                    onClick={this.handleSort('id')}>
                                    <Input
                                        placeholder='ID'
                                        style={{ width: '70px' }}
                                        onChange={this.handleIdChange}
                                        onClick={this.handleChildSort}
                                        value={idFilter}
                                    />
                                </Table.HeaderCell>
                            )}
                            {(this.props.authUser.role === 'dco' || this.props.authUser.role === 'administrator') && (
                                <Table.HeaderCell
                                    sorted={column === 'userName' ? direction : null}
                                    onClick={this.handleSort('userName')}>
                                    User
                                </Table.HeaderCell>
                            )}
                            <Table.HeaderCell
                                sorted={column === 'coverageId' ? direction : null}
                                onClick={this.handleSort('coverageId')}>
                                <Input
                                    placeholder='Coverage ID'
                                    style={{ width: '105px' }}
                                    onChange={this.handleCoverageIdChange}
                                    onClick={this.handleChildSort}
                                    value={coverageFilter}
                                />
                            </Table.HeaderCell>
                            <Table.HeaderCell
                                sorted={column === 'status' ? direction : null}
                                onClick={this.handleSort('status')}>
                                <Dropdown
                                    placeholder='Status'
                                    style={{ width: '150px' }}
                                    options={statusOptions}
                                    onChange={this.handleStatusChange}
                                    search selection compact clearable
                                />
                            </Table.HeaderCell>
                            <Table.HeaderCell
                                sorted={column === 'lastModified' ? direction : null}
                                onClick={this.handleSort('lastModified')}>
                                Last Modified
                            </Table.HeaderCell>
                            <Table.HeaderCell />
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {applications.map(app => (
                            <Table.Row key={app.id}>
                                {(this.props.authUser.role === 'dco' || this.props.authUser.role === 'administrator') && (
                                    <Table.Cell>{app.id}</Table.Cell>
                                )}
                                {(this.props.authUser.role === 'dco' || this.props.authUser.role === 'administrator') && (
                                    <Table.Cell>{app.userName}</Table.Cell>
                                )}
                                <Table.Cell>{app.coverageId}</Table.Cell>
                                <Table.Cell>{app.displayStatus}</Table.Cell>
                                <Table.Cell>{app.lastModified}</Table.Cell>
                                <Table.Cell collapsing>
                                    <Popup trigger={
                                            <Button basic icon='folder open outline' color='green' as={Link} to={`/application/${app.id}`} />
                                        } content='Open Application'
                                    />
                                    {app.status === 'SUBMITTED' && (
                                        <Popup trigger={
                                            <Button basic icon='file pdf outline' color='teal' onClick={() => this.downloadCPAPPDF(app.id)} target='_blank' />
                                        } content='Export Application'
                                        />
                                    )}

                                    {((this.props.authUser.role === 'dco' || this.props.authUser.role === 'administrator') && (app.status === 'REVIEW' || app.status === 'REJECTED' || app.dueDateOverridden || app.ownershipOverridden || app.correctionsOverridden)) && (
                                        <Popup trigger={
                                            <ApplicationReview
                                                applicationId={app.id}
                                                alreadyOverriden={app.status === 'REJECTED' || app.status === 'EDIT'}
                                                trigger={<Button basic icon='eye' color={(app.status === 'REVIEW' && app.mutualCompanyAffiliated === 'N') && !app.ownershipOverridden ? 'blue' : 'violet'} />
                                                }
                                            />
                                        } content='Review errors'
                                    />
                                    )}
                                    {((this.props.authUser.email === app.userName || this.props.authUser.role === 'dco') && app.status === 'EDIT') && (
                                        <Popup trigger={
                                            <Button basic icon='trash' color='red' />
                                        } content={<Button color='green' content='Confirm delete' onClick={() => this.handleDelete(app.id)} /> } on='click'
                                        />
                                    )}
                                    {this.props.authUser.role === 'administrator' && (
                                        <Popup trigger={
                                            <Button basic icon='options' color='black' />
                                        } content={
                                            <List>
                                                <List.Item>
                                                    <List.Icon>
                                                        <Button basic icon='trash' color='red' onClick={() => this.handleDelete(app.id)} on='click' />
                                                    </List.Icon>
                                                    <List.Content>
                                                        <List.Header>Delete Application</List.Header>
                                                    </List.Content>
                                                </List.Item>
                                                {app.status === 'SUBMITTED' && (
                                                    <List.Item>
                                                        <List.Icon>
                                                            <Button basic icon='mail' color='yellow' onClick={() => this.handleResubmitEmail(app.id)} loading={resubmitAppEmailLoading}/>
                                                        </List.Icon>
                                                        <List.Content>
                                                            <List.Header>Resend Submission Email</List.Header>
                                                        </List.Content>
                                                    </List.Item> )
                                                }
                                                {app.status === 'SUBMITTED' && ( 
                                                    <List.Item>
                                                        <List.Icon>
                                                            <Button basic icon='file image outline' color='green' onClick={() => this.handleImageApplication(app.id, app.coverageId)} loading={resubmitAppImagingLoading} />
                                                        </List.Icon>
                                                        <List.Content>
                                                            <List.Header>Send Application to Imaging</List.Header>
                                                        </List.Content>
                                                    </List.Item> )
                                                }
                                            </List>
                                        } position="right center" on='click' on />
                                    )}


                                </Table.Cell>
                        </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
                <Dropdown compact selection options={pageSizeOptions} defaultValue={10} onChange={this.handlePageSizeChange} />
                {pageSize !== -1 && (
                    <Pagination
                        style={{ float: 'right' }}
                        totalPages={numberOfPages}
                        activePage={activePage}
                        onPageChange={this.handlePaginationChange}
                    />
                )}
            </div>
        );
    }
}

export default ApplicationTable;